import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { TbrState } from 'src/common/interfaces/states/TbrState';
import { POSModeState } from '../../interfaces/states/POSModeState';

export const initialState: TbrState = {
  tbrItemsList: [],
  selectedItemSequenceNumber: 0,
};

class TbrReducer extends ImmerReducer<TbrState> {
  public setState(state: Partial<POSModeState>): void {
    this.draftState = { ...this.draftState, ...state };
  }

  public setTBRItemsList(itemsList: IElectronicJournalRecord[]): void {
    this.draftState = {
      ...this.draftState,
      tbrItemsList: itemsList,
    };
  }

  public updateTbrItemList(itemQuantityMap: Map<number, number>, selectedLineId: number): void {
    this.draftState.tbrItemsList.forEach(item => {
      const updatedQuantity = itemQuantityMap.get(item.SequenceNumber);
      item.tbrReturnQty = updatedQuantity || 0;
      item.Selected = item.SequenceNumber === selectedLineId && item.Type === EJRecordTypes.Product;
    });
  }

  public resetState(): void {
    this.draftState = initialState;
  }
}

export const TbrActions = createActionCreators(TbrReducer);
export const TbrReducerFunction = createReducerFunction(TbrReducer, initialState);
